export default __webpack_public_path__ + "static/metrics.administration-3e16e40dc0da743aeede55de08add586.png";